<template>
  <div
    class="core-buttons"
    :class="layoutClass"
  >
    <TheContent :elem="content" />
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import type { ILayout } from '~/types/components/Buttons';
  import type { TContent } from '~/types/common';
  import TheContent from '~/components/TheContent';

  export default defineNuxtComponent({
    name: 'CoreButtons',

    components: {
      TheContent,
    },

    props: {
      href: {
        type: String,
        default: null,
      },

      content: {
        type: Object as PropType<TContent | null>,
        default: null,
      },

      // не уверен, что используется вообще
      layout: {
        type: Object as PropType<ILayout>,
        default: () => ({
          type: 'flex',
          justifyContent: 'center',
        }),
      },
    },

    computed: {
      layoutClass(): string[] {
        const classNames: string[] = [];

        if (this.layout) {
          Object.values(this.layout).forEach((item) => {
            classNames.push(`core-buttons--${item}`);
          });
        }

        return classNames;
      },
    },
  });
</script>

<style lang="scss" scoped>
  .core-buttons {
    &--flex {
      display: flex;
    }

    &--left {
      justify-content: flex-start;
    }

    &--center {
      justify-content: center;
    }

    &--right {
      justify-content: flex-end;
    }

    &--space-between {
      justify-content: space-between;
    }
  }
</style>
